export const EMPLOYEE_DOCUMENTS_MODALS = {
  createDocument: 'createDocument',
  uploadDocument: 'uploadDocument',
};
